import Vue from 'vue'
import Vuex from 'vuex'


import auth from './modules/auth'
import console from './modules/console'
import qr from './modules/qr'
import services from './modules/services'


Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    auth,
    console,
    qr,
    services,
  },
  
  strict: debug,
})

